module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('span', {
    staticClass: "word-wrapper"
  }, [_vm._c('span', {
    staticClass: "word",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.select($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.word))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-454bd832!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/WordbankWord.vue
// module id = 651
// module chunks = 1